import { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import ConfirmBankPayment from "../../shared/ConfirmBankPayment";

const OplConfirmBankPayment = () => {
  const navigate = useNavigate();
  const { merchant, methodStepData, paymentParameters } = useOutletContext();

  useEffect(() => {
    if (!methodStepData || !methodStepData.institution) {
      navigate(`/payto/${merchant.organisationId}`);
    }
  }, []);

  return (
    methodStepData &&
    methodStepData.institution && (
      <ConfirmBankPayment
        institution={methodStepData.institution}
        merchant={merchant}
        paymentParameters={paymentParameters}
        returnUrl={`/payto/${merchant.organisationId}/choosepaymentmethod`}
      />
    )
  );
};
export default OplConfirmBankPayment;
